import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { ModalLayout } from '@appbase/templates'
import PurchaseHistory from './PurchaseHistory.vue';

@Component({
    components: { ModalLayout, PurchaseHistory }
})
export default class PurchaseHistoryModal extends Vue {

    handleClose() {
        this.closeCurrentModal()
    }
}
